import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';

@Component({
   selector: 'custom-select',
   templateUrl: './custom-select.component.html',
   styleUrls: [],
   encapsulation: ViewEncapsulation.None
})
export class CustomSelectComponent implements OnInit {
   @Input() Width: string = '300px';
   @Output() reload: EventEmitter<any> = new EventEmitter();
   
   constructor() {
   }
   
   ngOnInit() {
   }
   
   loadData() {
      this.reload.emit();
   }
}
